import { FC } from 'react';

import { DeleteBin5Line, FireLine, HistoryFill } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';

import { HeaderWrapper, IconButton, PastSearchesTitle } from './styled';

interface IHeader {
  label?: string;
  iconType?: 'history' | 'popular';
  handleClear?: () => void;
  className?: string;
}

const Icons = {
  history: HistoryFill,
  popular: FireLine,
};

const Header: FC<IHeader> = ({
  label = 'Son Aramalar',
  handleClear,
  className,
  iconType = 'history',
}) => {
  const Icon = Icons[iconType];

  return (
    <HeaderWrapper className={className}>
      <CustomIcon icon={Icon} fontSize={16} paletteColor='grey800' />
      <FlexibleDiv right={4} />
      <PastSearchesTitle>{label}</PastSearchesTitle>
      {typeof handleClear === 'function' ? (
        <IconButton onClick={handleClear}>
          <CustomIcon
            icon={DeleteBin5Line}
            fontSize={16}
            paletteColor='grey800'
          />
        </IconButton>
      ) : null}
    </HeaderWrapper>
  );
};

export default Header;
